import { t } from 'i18next'
import { useLocation, useNavigate, useParams } from 'react-router-dom'

import styles from './DocumentBackOffice.module.scss'
import { MoreVert } from '../../../../../assets/Icons'
import {
  useAppDispatch,
  useAppSelector,
  useIsBelowBreakpoint,
} from '../../../../../hooks'
import { FileInformation } from '../../../../../redux-store/models'
import { Button } from '../../../../common'
import {
  currentDocumentsSelector,
  removeDocument,
  removeMainDocument,
} from '../../api/currentDocumentsSlice'
import DocumentMorePopover from '../DocumentMorePopover/DocumentMorePopover'
import FavoriteButton from '../FavoriteButton/FavoriteButton'

const DocumentBackOfficeHeader = ({
  draftishFile,
}: {
  draftishFile?: FileInformation | null
}): JSX.Element => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const location = useLocation()
  const isTabLand = useIsBelowBreakpoint('tabLand')
  const { documentId = '' } = useParams()
  const currentMainDocument = useAppSelector(
    currentDocumentsSelector.selectMainDocument
  )
  const currentDocuments = useAppSelector(
    currentDocumentsSelector.selectCurrentDocuments
  )

  const handleDocumentDelete = () => {
    if (currentMainDocument && currentMainDocument.id === documentId) {
      dispatch(removeMainDocument())
    }

    if (
      currentDocuments?.length > 0 &&
      currentDocuments.find((d) => d.id === documentId)
    ) {
      dispatch(removeDocument(documentId))
    }
  }

  const handleSidebarOpen = () => {
    navigate(
      {
        ...location,
        hash: 'drawer',
      },
      { replace: true }
    )
  }

  return (
    <header className={styles.root}>
      {!isTabLand && (
        <DocumentMorePopover
          className={styles.moreBtn}
          documentId={documentId}
          styleInverted={true}
          editFileType={draftishFile ? draftishFile.extension : ''}
          onDocumentDelete={handleDocumentDelete}
        />
      )}
      {isTabLand && (
        <Button
          size="small"
          variant="subtle"
          icon={<MoreVert />}
          onClick={handleSidebarOpen}
          className={styles.sidebarBtn}
          aria-label={t('frontOffice.ariaSidebarBtn') ?? ''}
          as="button"
        />
      )}
      <FavoriteButton className={styles.favBtn} styleInverted={true} />
    </header>
  )
}

export default DocumentBackOfficeHeader
